import { getCoverEventPosterImage } from '@/features/events/shared/FocalEventPosterImage';
import type {
  DiscoveryEvent,
  ProfileSummary,
  VenuePublicDeal,
  VenueSummary,
} from '@/lib/api/apiTypes';
import { getEventPath, getVenuePath } from '@/lib/navigation/routes';
import type { RecentSearchEntry } from './useRecentSearches';

export function buildRecentEvent(event: DiscoveryEvent): RecentSearchEntry {
  const posterImage = getCoverEventPosterImage(event);
  return {
    key: `event:${event.id}`,
    type: 'event',
    title: event.title,
    subtitle: event.venue_name || 'Venue TBD',
    image_url: posterImage?.public_url ?? null,
    poster_image: posterImage,
    route: getEventPath(event.id, event.title) as RecentSearchEntry['route'],
  };
}

export function buildRecentProfile(profile: ProfileSummary): RecentSearchEntry {
  return {
    key: `profile:${profile.user_id}`,
    type: 'profile',
    title: profile.display_name || profile.username,
    subtitle: `@${profile.username}`,
    image_url: profile.avatar_url || null,
    route:
      profile.is_venue && profile.venue_id
        ? (getVenuePath(profile.venue_id, {
            name: profile.venue_name,
          }) as RecentSearchEntry['route'])
        : `/profiles/${profile.username}`,
  };
}

export function buildRecentVenue(venue: VenueSummary): RecentSearchEntry {
  return {
    key: `venue:${venue.id}`,
    type: 'venue',
    title: venue.name,
    subtitle: venue.address || 'Venue',
    image_url: venue.logo_url || null,
    route: getVenuePath(venue.id, { name: venue.name }) as RecentSearchEntry['route'],
  };
}

export function buildRecentDeal(deal: VenuePublicDeal): RecentSearchEntry {
  return {
    key: `deal:${deal.id}`,
    type: 'deal',
    title: deal.title,
    subtitle: deal.venue_name,
    image_url: deal.logo_url || null,
    route: getVenuePath(deal.venue_id, { name: deal.venue_name }) as RecentSearchEntry['route'],
  };
}

export function buildRecentQuery(query: string): RecentSearchEntry {
  return {
    key: `query:${query.toLowerCase()}`,
    type: 'query',
    title: query,
    subtitle: 'Search query',
    query,
  };
}
